import Icon from '../Icon'
import { PointerIcon, PointerText, PointerWrapper } from './Pointer.styles'

interface PointerProps {
  children: React.ReactNode
}

const Pointer = ({ children }: PointerProps) => {
  return (
    <PointerWrapper>
      <PointerText>{children}</PointerText>
      <PointerIcon>
        <Icon name="angle-down" />
        <Icon name="angle-down" />
      </PointerIcon>
    </PointerWrapper>
  )
}

export default Pointer
